/* Hallow Vault — theme.js */
(function () {
  'use strict';

  /* Mobil menyu */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hv-burger]');
    if (!b) return;
    var nav = document.getElementById('hv-nav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Skroll ilə üzə çıxma */
  function reveal() {
    var els = document.querySelectorAll('.hv-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Qalereya */
  function gallery(root) {
    var main = root.querySelector('[data-hv-main]');
    if (!main) return;
    root.querySelectorAll('[data-hv-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-hv-thumb]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');
        var idx = t.getAttribute('data-hv-thumb');
        root.querySelectorAll('[data-hv-slide]').forEach(function (s) {
          var on = s.getAttribute('data-hv-slide') === idx;
          s.hidden = !on;
          var v = s.querySelector('video');
          if (v) { on ? v.play().catch(function(){}) : v.pause(); }
        });
      });
    });
  }

  /* Bundle seçimi — YALNIZ quantity dəyişir, variant id-yə TOXUNULMUR */
  function bundle(root) {
    var qtyInput = root.querySelector('[data-hv-qty]');
    var opts = root.querySelectorAll('[data-hv-bundle]');
    if (!qtyInput || !opts.length) return;
    var totalEl = root.querySelector('[data-hv-total]');
    var saveEl = root.querySelector('[data-hv-save]');
    var stickyEl = root.querySelector('[data-hv-sticky-total]');

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        o.classList.add('is-active');
        o.setAttribute('aria-checked', 'true');

        var q = parseInt(o.getAttribute('data-hv-qty-val'), 10) || 1;
        qtyInput.value = q;   /* <- yalnız bu dəyişir */

        var total = o.getAttribute('data-hv-total-str') || '';
        var save = o.getAttribute('data-hv-save-str') || '';
        if (totalEl) totalEl.textContent = total;
        if (stickyEl) stickyEl.textContent = total;
        if (saveEl) { saveEl.textContent = save; saveEl.hidden = !save; }
      });
    });
  }

  /* FAQ */
  function faq(root) {
    root.querySelectorAll('[data-hv-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-hv-faq-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        var a = item.querySelector('[data-hv-faq-a]');
        if (a) a.hidden = !open;
      });
    });
  }

  /* Telefonda sabit alt panel — alış qutusu ekrandan çıxanda görünür */
  function sticky() {
    var bar = document.querySelector('[data-hv-sticky]');
    var box = document.querySelector('[data-hv-buybox]');
    if (!bar || !box) return;
    var atc = box.querySelector('[data-hv-atc]');
    if (!atc) return;
    var ticking = false;

    function update() {
      ticking = false;
      var r = atc.getBoundingClientRect();
      var show = r.bottom < 72;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* Ölkə/valyuta seçimi dəyişəndə formanı göndər */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-hv-loc]') && el.form) { el.form.submit(); }
  });

  function init() {
    reveal();
    sticky();
    document.querySelectorAll('[data-hv-gallery]').forEach(gallery);
    document.querySelectorAll('[data-hv-buybox]').forEach(bundle);
    document.querySelectorAll('[data-hv-faq]').forEach(faq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
